<template>
  <div class="awards-section">
    <div class="image-container">
      <img :src="img" alt="Yunus Rajabiy" />
    </div>
    <div class="text-container">
      <h1>{{ $t('awardsTitle9') }}</h1>
      <p>{{ $t('awardsDescription10') }}</p>
      <hr>
      <div class="awards-list">
        <div class="award-item">
          <h4><span class="date"></span> {{ $t('awardItem11') }}</h4>
        </div>
        <hr>
        <div class="award-item">
          <h4><span class="date"></span> {{ $t('awardItem12') }}</h4>
        </div>
        <hr>
        <div class="award-item">
          <h4><span class="date"></span> {{ $t('awardItem13') }}</h4>
        </div>
        <hr>
        <div class="award-item">
          <h4><span class="date"></span> {{ $t('awardItem14') }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import img from "@/assets/images/2.jpg";
export default {
  data() {
    return {
      img,
    };
  },
};
</script>

<style scoped>
.awards-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #12130d;
  margin: 100px 0 30px 0;
  flex-wrap: wrap;
}

.image-container {
  flex: 1;
  max-width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.image-container img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.text-container {
  flex: 1;
  margin-left: 30px;
  color: #ebe9cf;
  margin: 30px;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

p {
  font-size: 1.1rem;
  margin-bottom: 30px;
}

.awards-list {
  margin-top: 30px;
}

.award-item {
  margin: 15px 0;
}

.award-item h4 {
  font-size: 1.2rem;
  font-weight: 500;
  color: #ebe9cf;
}

.date {
  font-weight: bold;
  color: #ebe9cf;
  margin-right: 10px;
}

hr {
  border: 1px solid #ebe9cf;
  margin: 15px 0;
}


@media (max-width: 768px) {
  .awards-section {
    flex-direction: column-reverse;
    align-items: center;
    text-align: center;
  }

  .image-container {
    max-width: 100%;
    margin-bottom: 20px;
  }

  .text-container {
    margin-left: 0;
    margin-right: 0;
    text-align: center;
  }

  h1 {
    font-size: 2rem;
  }

  p {
    font-size: 1rem;
    margin-bottom: 20px;
  }

  .award-item h4 {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 1.5rem;
  }

  p {
    font-size: 0.9rem;
  }

  .award-item h4 {
    font-size: 0.9rem;
  }

  .date {
    font-size: 0.8rem;
  }

  .image-container img {
    width: 410px;
  }
}

</style>
